export async function getAccountAssets(account) {
    return getTableRows("atomicassets", account, "assets", "", "");
}
export async function getWaxPriceInUSD() {
    const url = "https://api.coingecko.com/api/v3/simple/price?ids=wax&vs_currencies=usd";
    const res = await fetch(url);
    return res.json();
}
export async function getAlcorPrice(market) {
    const url = `https://wax.alcor.exchange/api/markets/${market}`;
    const res = await fetch(url);
    return res.json();
}
export async function getTableRows(code, scope, table, lower_bound = "", upper_bound = "") {
    const url = "https://api.wax.alohaeos.com/v1/chain/get_table_rows";
    const options = {
        method: "POST",
        body: JSON.stringify({
            code,
            index_position: 1,
            json: true,
            key_type: "i64",
            limit: 1000,
            lower_bound,
            reverse: false,
            scope,
            show_player: false,
            table,
            upper_bound,
        }),
    };
    const res = await fetch(url, options);
    const body = await res.json();
    return body.rows;
}
export async function fetchStakingConfigs() {
    return getTableRows("s.rplanet", "s.rplanet", "pools");
}
export async function fetchAccountCollectionStaking(account, collection) {
    const result = await getTableRows("s.rplanet", collection, "accounts", account, account);
    const staking = result[0];
    if (staking) {
        staking.collection = collection;
    }
    else {
        //console.log(`Collection ${collection} not found`);
    }
    return staking;
}
